import { Link, Outlet } from "react-router";
import { useTranslation } from "@repo/i18n";
import { css } from "@repo/styled-system/css";

/**
 * Shell for the operator back office (super-admin.md). A deliberately plain, platform-only chrome —
 * distinct from the venue-scoped staff shell — so an operator always knows they are in the cross-tenant
 * surface, not a single venue. The `/ops` subtree mounts under this; [RequireOperator] gates the route.
 */
export function OpsLayout() {
  const { t } = useTranslation();
  return (
    <div className={css({ minH: "100vh", bg: "bg.canvas" })}>
      <header
        className={css({
          display: "flex",
          alignItems: "center",
          gap: "3",
          px: "6",
          py: "3",
          borderBottomWidth: "1px",
          borderColor: "border.default",
          bg: "bg.subtle",
        })}
      >
        <Link to="/ops" className={css({ fontWeight: "bold", fontSize: "lg" })}>
          {t("ops.title")}
        </Link>
        <span className={css({ color: "fg.muted", fontSize: "sm" })}>{t("ops.subtitle")}</span>
      </header>
      <main className={css({ p: "6", maxW: "5xl", mx: "auto" })}>
        <Outlet />
      </main>
    </div>
  );
}
